import React from "react";
import {toast} from "react-toastify";
import AlertIcon from "components/molecules/AlertIcon";
import {StyledAlert, Message} from "components/molecules/Toast/Toast.styles";

function Toast({type, message, ...props}) {
    return toast(
        <>
            <StyledAlert $type={type} {...props}>
                <AlertIcon $type={type} />
                <Message $type={type}>{message}</Message>
            </StyledAlert>
        </>,
        {
            hideProgressBar: true,
            autoClose: 2000,
        }
    );
}

export default Toast;
